export const CESAREAN = { id: 'cesarean', label: 'Taglio cesareo elettivo' };
export const NO_CESAREAN = { id: 'no_cesarean', label: 'Taglio cesareo non elettivo' };
